const experience = 
    [

        {
            id: "01",
            date: "Apr 2024 - Aug 2024", 
            role: "Admin Assistant",    
            content: "*- Performed data cleaning on Excel, created reference tables, and formatted data into provided templates. Created formulas within Excel to reduce 30% of manual checking, freeing up an accumulated 24-30 hours to focus on critical business needs.\
            *- Created Excel and Power BI templates for future usage on analysing parts inventory on a regional level across 6 countries.",
            organization: "Epson Singapore",
            category: "Full-Time",
        },
        
        {
            id: "02",
            date: "Sep 2023 - Nov 2023", 
            role: "Data Science Intern",    
            content: "*- Created a Keyword association model that can analyze multiple documents and return a list of words associated with a keyword, and their ranking/occurrences.\
            *- Developed a User-friendly interface for non-tech users to self-help.",
            organization: "Centre for Strategic Infocomm Technologies",
            category: "Internship",
        },
  
        {
            id: "03",
            date: "Sep 2022 - Oct 2022", 
            role: "Service Crew",
            content: "*- Assisted in Formula One 2022 by managing drink inventory and stock inventory transfer between Pan Pacific Hotel and Formula One suites. \
            *- Good inventory management resulted in no delays or issues during the event.",
            organization: "Pan Pacific Singapore",
            category: "Part-Time",
        },
  
        {
            id: "04",
            date: "Dec 2020 - Sep 2022", 
            role: "Service Crew",
            content: "*- Attained WSQ Basic Food Hygiene Certification\
            *- Prepare and serve food and drinks\
            *- Clean and maintain the dining area\
            *- Handled customer complaints, supported customer needs, and promoted products to customers, exceeding sales targets.",
            organization: "RE&S Enterprise Pte. Ltd.",
            category: "Part-Time",
        }
  ];
  
  export default experience;
  
